"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.queryClientGenerator = void 0;
const react_query_1 = require("@tanstack/react-query");
function queryClientGenerator(overrides) {
    var _a, _b, _c;
    const queries = Object.assign({ retry: restRetryHandler }, ((_b = (_a = overrides === null || overrides === void 0 ? void 0 : overrides.defaultOptions) === null || _a === void 0 ? void 0 : _a.queries) !== null && _b !== void 0 ? _b : {}));
    return new react_query_1.QueryClient({
        defaultOptions: Object.assign(Object.assign({}, ((_c = overrides === null || overrides === void 0 ? void 0 : overrides.defaultOptions) !== null && _c !== void 0 ? _c : {})), { queries }),
    });
}
exports.queryClientGenerator = queryClientGenerator;
const commonErrors = [400, 401, 403, 404];
function restRetryHandler(failureCount, error) {
    const status = error.status;
    if (status && commonErrors.includes(status)) {
        return false;
    }
    else {
        return failureCount < 5;
    }
}
//# sourceMappingURL=queryClientGenerator.js.map